import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';

import Modal from 'react-modal';
import Iframe from 'react-iframe';

import BUILDING_TYPE_ICONS from './icons';


const listStyles = {
	display: 'flex',
	flexDirection: 'column',
	overflowY: 'auto',
	padding: '0px 0px 0px 0px',
	userSelect: 'text',
}

class PopupContentComponent extends Component {
    convertToClick (e) {
    	// ugly hack since popup is stopping events propagation:
    	// https://github.com/openlayers/openlayers/issues/6948
		const evt = new MouseEvent('click', { bubbles: true })
		evt.stopPropagation = () => {}
		e.target.dispatchEvent(evt)
    }

    onClick(id) {
    	const { onClick } = this.props

    	this.setState({multiselectSelected: id})

    	onClick(id)
    }

    async componentDidMount() {
        let resp = await fetch('/api/metadata?fields_schema', {credentials: 'include'})
        let data = await resp.json()
        this.setState({
            FIELDS_SCHEMA: data['fields_schema']
        })
    }

    openModal(tour) {
        const {onCollapseSidebar, openVirtualTour, openPanel} = this.props
        // Original tours are served by this Compose on HTTPS and on port 8888.
        this.setState({tour: tour.replace(/^https?:\/\/sport\.cityscanner\.ru(?=\/)/, '')});
        openPanel(false)
        onCollapseSidebar(true)
        openVirtualTour(true)
    }
    closeModal() {
        const {onCollapseSidebar, openVirtualTour, openPanel} = this.props
        this.setState({tour: null});
        onCollapseSidebar(false)
        openVirtualTour(false)
        openPanel('editor')
    }

    render () {
        const { selected, places, isTourOpened,
        	 openPanel, changeShowFilters, onCollapseSidebar } = this.props
        const selectedPlaces = places.filter(place => {
        	if (selected) {
	        	if (typeof(selected) == 'number') {
	        		return place.id == selected
	        	} else if ( typeof(selected) == 'object' ) {
	        		return selected.includes(place.id)
	        	} else {
	        		return false
	        	}
	        }
        	else {
        		return false
        	}
        })

        if (selectedPlaces.length === 0){
            return null
        }

        const placesToShow = selectedPlaces.map(place => (
            <ListItem
            	key={'popup_listing_' + place.id}
            	style={listStyles}
            >	
            	<div style={{alignItems: 'flex-start'}}>
	            	<Typography variant='button' style={{display: 'flex'}}>
	            		<img
	            			src={BUILDING_TYPE_ICONS[place.building_type]} 
	            			style={{height: '5.5em', marginRight: '1em'}}
	            		/>
	            		<p style={{'marginTop': '0px', 'marginBottom': '0px'}}>
                            {place.name && (place.name.split(' ').length > 6 ? place.name.split(' ').slice(0, 6).join(' ') + '...' : place.name)}
                        </p>
	            	</Typography>
	            	<Typography variant='caption'>
	            		{place.address && (place.address.replace(/\d+,? Свердловская (область|обл\.?),? /, ''))}
	            	</Typography>
	            	<Divider style={{width: '100%'}}/>
	            	<Typography variant='body1' style={{textAlign: 'left'}}>{place.building_type && this.state.FIELDS_SCHEMA.default.fields.building_type.options[place.building_type]}</Typography>
	              	<Divider style={{width: '100%'}}/>
	              	<Typography style={{textAlign: 'left'}}>{place.description}</Typography>
	            </div>
              	<div style={{display: 'flex'}}>
              	<Button onClick={() => {this.onClick(place.id); changeShowFilters(false); openPanel('editor');}} color='primary' style={{flexGrow: '1', flexBasis: '40%'}}>Подробнее</Button>
              	{place.tour ?
                    <Button
                        onClick={() => this.openModal(place.tour)}
                        color='primary'
                        style={{flexGrow: '1'}}
                    >
                    Виртуальный тур
                    </Button>
                : null}
                </div>
            </ListItem>
        ))

        return (
            <div id='popup-content' onMouseUp={this.convertToClick}>
            	<List dense={true}>{placesToShow}</List>
            	{isTourOpened ?
	                <Modal
	                  isOpen={isTourOpened}
	                  onAfterOpen={()=>onCollapseSidebar(true)}
	                  onRequestClose={()=>this.closeModal()}
	                  contentLabel="Виртуальный тур"
	                >
	                <Button
	                    style={{right: '0px', top: '0px', position: 'absolute'}}
	                    onClick={() => this.closeModal()}
	                >
	                  <CloseIcon />
	                </Button>
	                    <Iframe
	                        url={this.state.tour}
	                        width='100%'
	                        position='static'
	                    />
	                </Modal>
	                : null
	            }
            </div>
        )
    }
}

export default PopupContentComponent



// WEBPACK FOOTER //
// ./src/PopupContentComponent.js